import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  selectors as routerSelectors,
  actions as routerActions
} from "../redux/router";
import { Route as SimpleRoute } from "react-router-dom";
import { isRelativeURL } from "../redux/router/utils";
import { ssoToOldOnlineURL } from "../ui/utils/location";
import { selectors as userSelectors } from "../redux/user";

/**
 * That to.slice(2) is because of how we handle building the url with a hash
 */
const ConnectedRedirect = ({ to, external, user, sso = true, ...props }) => {
  if (external) {
    return (
      <SimpleRoute
        path={props.to}
        component={() => {
          if (sso) {
            ssoToOldOnlineURL(to, false, user);
          } else {
            window.location = to;
          }
          return null;
        }}
      />
    );
  } else {
    return <Redirect {...props} to={to.slice(2)} />;
  }
};

const mapStateToProps = (state, ownProps) => {
  // We should be able to handle our own external checks
  const external = ownProps.external || !isRelativeURL(ownProps.to);
  return {
    user: userSelectors.getUser(state),
    external,
    to: external
      ? ownProps.to
      : routerActions.buildUrl(
          state,
          ownProps.to,
          routerSelectors.getQueryParams(state)
        )
  };
};

export default connect(mapStateToProps)(ConnectedRedirect);
